<template>
    <div class="form-group">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.form-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px; 
}
</style>